import { useState } from 'react';
import { Gift, Sparkles, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import api from '@/lib/api';

export default function WelcomeVaultModal({ onClose, onPrizeWon }) {
  const [phase, setPhase] = useState('ready');
  const [prize, setPrize] = useState(0);

  const openVault = async () => {
    setPhase('opening');
    try {
      const res = await api.post('/users/open-vault');
      setPrize(res.data.prize);
      setTimeout(() => setPhase('reveal'), 1200);
      if (onPrizeWon) onPrizeWon(res.data.bisne_cash);
    } catch {
      onClose();
    }
  };

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center p-4" data-testid="vault-modal">
      <div className="absolute inset-0 bg-black/80 backdrop-blur-sm" onClick={phase === 'reveal' ? onClose : undefined} />
      <div className="relative bg-zinc-900 border border-zinc-800 rounded-3xl w-full max-w-sm overflow-hidden shadow-2xl">
        {phase === 'reveal' && (
          <button data-testid="vault-close" onClick={onClose} className="absolute top-4 right-4 z-10 text-zinc-500 hover:text-white transition-colors">
            <X className="w-5 h-5" />
          </button>
        )}

        <div className="p-8 text-center">
          {/* Ready state */}
          {phase === 'ready' && (
            <div className="space-y-6">
              <div className="w-24 h-24 mx-auto rounded-full bg-primary/10 border-2 border-primary/30 flex items-center justify-center">
                <Gift className="w-12 h-12 text-primary" />
              </div>
              <div>
                <h2 className="font-heading text-2xl text-foreground">Bienvenido a Bisne</h2>
                <p className="text-zinc-400 font-body text-sm mt-2 leading-relaxed">Tienes una boveda de bienvenida esperandote. Abrela y descubre tu regalo.</p>
              </div>
              <Button data-testid="vault-open-btn" onClick={openVault}
                className="w-full rounded-full font-body font-bold text-base bg-primary text-primary-foreground hover:bg-primary/90 shadow-lg shadow-primary/25 h-14">
                <Gift className="w-5 h-5 mr-2" /> Abrir Boveda
              </Button>
              <p className="text-zinc-600 font-body text-xs">100% gratis. Sin trucos.</p>
            </div>
          )}

          {/* Opening animation */}
          {phase === 'opening' && (
            <div className="space-y-6 py-4">
              <div className="w-24 h-24 mx-auto rounded-full bg-primary/20 flex items-center justify-center animate-pulse">
                <Gift className="w-12 h-12 text-primary animate-bounce" />
              </div>
              <p className="text-zinc-400 font-body text-sm animate-pulse">Abriendo tu boveda...</p>
            </div>
          )}

          {/* Prize reveal */}
          {phase === 'reveal' && (
            <div className="space-y-5 py-2">
              <div className="w-20 h-20 mx-auto rounded-full bg-primary/15 flex items-center justify-center">
                <Sparkles className="w-10 h-10 text-primary" />
              </div>
              <div>
                <p className="text-zinc-400 font-body text-xs uppercase tracking-wider mb-1">Ganaste</p>
                <p data-testid="vault-prize" className="font-heading text-5xl text-primary leading-none">${prize}</p>
                <p className="font-body text-base text-foreground mt-1">Bisne Cash</p>
              </div>
              <p className="text-zinc-500 font-body text-xs leading-relaxed">Tu saldo fue agregado a tu cartera. Usalo en futuras promociones.</p>
              <Button data-testid="vault-done-btn" onClick={onClose}
                className="w-full rounded-full font-body font-semibold text-sm bg-zinc-800 text-foreground hover:bg-zinc-700 h-12 border border-zinc-700">
                Empezar a hacer bisne
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
